export default __webpack_public_path__ + "media/src/shared/contact-boxes/assets/agent_no_photo_210x210-a941e967beff320f8eb05d6157ea1a20.png";